<template>
  <div>
    <b-container fluid>
      <b-row class="justify-content-left mt-5">
        <b-col lg="6" md="12">
          <b-card bg-variant="dark" text-variant="white" class="shadow" no-body>
            <b-row no-gutters>
              <b-col md="5">
                <b-card-sub-title class="px-3 pt-3">
                  <h6>
                    <b-button
                      variant="outline-light"
                      size="sm"
                      :to="{ name: 'Client', params: { clientId: client.id } }"
                      ><font-awesome-icon icon="caret-left" class="mr-2" />{{
                        client.company
                      }}</b-button
                    >
                  </h6>
                </b-card-sub-title>
                <b-card-title class="px-3">
                  <h2 class="text-white">
                    {{ project.title }}
                  </h2>

                  <b-link
                    :href="`${frontUrl}/${project.random_slug}`"
                    target="_blank"
                    class="btn btn-sm btn-info mr-2"
                    ><font-awesome-icon
                      icon="external-link-alt"
                      class="mr-2"
                    />Javna povezava</b-link
                  >
                </b-card-title>
                <div class="mx-3">
                  <b-link
                    class="btn btn-sm btn-light text-dark mr-2"
                    v-b-modal.modal-editProject
                    ><font-awesome-icon icon="edit" class="mr-2" />Uredi
                    vsebine</b-link
                  >

                  <b-link v-if="project.isActive">
                    <b-link
                      @click="toggleProjectStatus()"
                      class="btn btn-danger btn-sm mr-2"
                      >Deaktiviraj</b-link
                    >
                  </b-link>
                  <b-link v-else>
                    <b-link
                      @click="toggleProjectStatus()"
                      class="btn btn-success btn-sm mr-2"
                      >Aktiviraj</b-link
                    >
                  </b-link>
                  <span class="mr-2">|</span>
                  <HelperImageUpload
                    v-bind:imgType="{
                      type: 'project',
                      imgType: 1,
                      label: 'Forma',
                      id: project.id,
                    }"
                  />

                  <HelperImageUpload
                    v-bind:imgType="{
                      type: 'project',
                      imgType: 2,
                      label: 'Intro',
                      id: project.id,
                    }"
                  />
                </div>
                <b-list-group flush class="rounded text-dark m-3">
                  <b-list-group-item
                    class="d-flex justify-content-between align-items-center"
                    >Št. kartic:
                    <b-badge variant="dark" pill>{{
                      project.count_cards
                    }}</b-badge></b-list-group-item
                  >
                  <b-list-group-item
                    class="d-flex justify-content-between align-items-center"
                    >Št. rezultatov:<b-badge variant="dark" pill>{{
                      project.count_results
                    }}</b-badge></b-list-group-item
                  >
                  <b-list-group-item
                    class="d-flex justify-content-between align-items-center"
                    >Št. prikazanih kartic :<b-badge variant="dark" pill>{{
                      project.matchup_length
                    }}</b-badge></b-list-group-item
                  >
                  <b-list-group-item
                    class="d-flex justify-content-between align-items-center"
                    >Sekvenca:<b-badge variant="dark" pill>{{
                      project.questions_sequence
                    }}</b-badge></b-list-group-item
                  >
                  <b-list-group-item
                    class="d-flex justify-content-between align-items-center"
                  >
                    Idealne sekvence:
                    <b-badge
                      variant="dark"
                      pill
                      v-if="project.count_sequences"
                      >{{ project.count_sequences }}</b-badge
                    >
                    <font-awesome-icon
                      v-if="!project.count_sequences"
                      icon="times-circle"
                      class="text-danger"
                    />
                  </b-list-group-item>
                </b-list-group>
              </b-col>
              <b-col md="7" class="bg-secondary">
                <b-list-group flush class="m-3">
                  <b-list-group-item>
                    <font-awesome-icon icon="cogs" class="text-muted mr-3" />
                    <b-link
                      v-b-modal.modal-buildMatchups
                      class="btn btn-dark btn-sm mr-2"
                    >
                      <font-awesome-icon icon="columns" class="mr-2" /> Št.
                      prikazanih kartic</b-link
                    >
                    <b-link
                      v-b-modal.modal-questionsSequence
                      class="btn btn-dark btn-sm mr-2"
                      ><font-awesome-icon
                        icon="ruler-horizontal"
                        class="mr-2"
                      />
                      Dolžina sekvence</b-link
                    >
                  </b-list-group-item>
                  <b-list-group-item class="text-dark">
                    <font-awesome-icon
                      icon="sort-amount-down-alt"
                      class="text-muted mr-3"
                    />
                    Upoštevaj vrstni red:
                    <b-link
                      :class="
                        project.custom_order ? 'text-success' : 'text-danger'
                      "
                      @click="toggleProjectOrder()"
                      ><font-awesome-icon
                        :icon="
                          project.custom_order ? 'toggle-on' : 'toggle-off'
                        "
                        size="lg"
                    /></b-link>
                  </b-list-group-item>
                  <b-list-group-item class="text-dark">
                    <font-awesome-icon
                      icon="not-equal"
                      class="text-muted mr-3"
                    />
                    Primerjava kartic? :
                    <b-link
                      :class="project.compare ? 'text-success' : 'text-danger'"
                      @click="toggleProjectCompare()"
                      ><font-awesome-icon
                        :icon="project.compare ? 'toggle-on' : 'toggle-off'"
                        size="lg"
                    /></b-link>
                  </b-list-group-item>
                  <b-list-group-item>
                    <font-awesome-icon icon="clone" class="text-muted mr-3" />
                    <b-link
                      class="btn btn-outline-dark btn-sm mr-2 "
                      v-b-modal.modal-uploadCards
                      ><font-awesome-icon
                        icon="cloud-upload-alt"
                        class="mr-2"
                      />
                      Naloži kartice</b-link
                    >
                    <b-link
                      class="btn btn-sm btn-danger mr-2"
                      @click="deleteCards()"
                      ><font-awesome-icon icon="trash" />
                    </b-link>
                  </b-list-group-item>
                  <b-list-group-item>
                    <font-awesome-icon icon="images" class="text-muted mr-3" />
                    <b-link
                      v-b-modal.modal-uploadImages
                      class="btn btn-outline-dark btn-sm my-xs-2 mr-2"
                      ><font-awesome-icon
                        icon="cloud-upload-alt"
                        class="mr-2"
                      />
                      Naloži slike</b-link
                    >
                    <b-link
                      class="btn btn-sm btn-danger mr-2"
                      @click="deleteImages"
                      ><font-awesome-icon icon="trash" />
                    </b-link>
                  </b-list-group-item>

                  <b-list-group-item>
                    <font-awesome-icon
                      icon="users-cog"
                      class="text-muted mr-3"
                    />
                    <b-link
                      v-b-modal.modal-uploadSequences
                      class="btn btn-outline-dark btn-sm mr-2"
                    >
                      <font-awesome-icon icon="bezier-curve" class="mr-2" />
                      Naloži sekvence</b-link
                    >
                    <b-link
                      class="btn btn-sm btn-danger mr-2"
                      @click="deleteSequences()"
                      ><font-awesome-icon icon="trash" />
                    </b-link>
                  </b-list-group-item>

                  <b-list-group-item variant="secondary">
                    <font-awesome-icon icon="poll" class="text-muted mr-3" />
                    <b-link
                      :href="
                        `${apiUrl}/api/dashboard/projects/${project.id}/respondents?jwt=${token}`
                      "
                      target="_blank"
                      class="btn btn-sm btn-outline-dark mr-2"
                      ><font-awesome-icon
                        icon="user-friends"
                        class="mr-2 "
                      />Anketiranci
                    </b-link>
                    <b-link
                      :href="
                        `${apiUrl}/api/dashboard/projects/${project.id}/results?jwt=${token}`
                      "
                      target="_blank"
                      class="btn btn-sm btn-outline-dark mr-2"
                      ><font-awesome-icon
                        icon="clipboard-list"
                        class="mr-2 "
                      />Rezultati
                    </b-link>
                    <b-link
                      class="btn btn-sm btn-danger "
                      @click="deleteResults()"
                      ><font-awesome-icon icon="trash" />
                    </b-link>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col lg="6" md="12">
          <b-card-group>
            <b-card
              header="Tekst pri vnosu podatkov"
              header-bg-variant="info"
              header-text-variant="white"
              no-body
              class="shadow"
            >
              <b-card-body v-html="project.description" />
              <b-card-footer v-if="project.desc_img">
                <img
                  class="img-fluid"
                  :src="`${helperImgPath}/${project.desc_img}`"
                />
              </b-card-footer>
            </b-card>
            <b-card
              header="Tekst na strani pred karticami"
              header-bg-variant="info"
              header-text-variant="white"
              no-body
              class="shadow"
            >
              <b-card-body v-html="project.intro_text" /><b-card-footer
                v-if="project.intro_img"
              >
                <img
                  class="img-fluid"
                  :src="`${helperImgPath}/${project.intro_img}`"
                />
              </b-card-footer>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div v-if="cards">
            <b-row class="text-center">
              <b-col cols="12">
                <h3 class="mt-5 text-center text-muted">
                  {{ project.matchup_title }}
                </h3>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col cols="12">
                <b-card-group columns>
                  <b-card
                    v-for="(card, index) in cards"
                    v-bind:key="index"
                    :img-src="card.image ? `${imgPath}/${card.image}` : ''"
                    img-top
                    class="mb-2 d-inline-block shadow"
                  >
                    <div v-if="card.attr_json">
                      <CardData
                        v-bind:attribs="JSON.parse(card.attr_json)"
                        v-bind:imgPath="imgPath + '/'"
                      />
                    </div>
                    <div v-else>
                      <b-list-group flush>
                        <b-list-group-item
                          v-for="(attr, index) in card.attributes"
                          v-bind:key="index"
                        >
                          {{ attr.label }}
                          <br />
                          <span class="font-weight-bold">{{ attr.value }}</span>
                        </b-list-group-item>
                      </b-list-group>
                    </div>
                  </b-card>
                </b-card-group>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <CardsUpload />
    <ImagesUpload />
    <BuildMatchups />
    <SetQuestions />
    <SequencesUpload />
    <EditProject v-bind:form="project" />
  </div>
</template>
<script>
import { mapState } from "vuex";

import CardsUpload from "@/components/uploaders/CardsUpload.vue";
import EditProject from "@/components/EditProject.vue";
import ImagesUpload from "@/components/uploaders/ImagesUpload.vue";
import BuildMatchups from "@/components/uploaders/BuildMatchups.vue";
import SetQuestions from "@/components/uploaders/SetQuestions.vue";
import SequencesUpload from "@/components/uploaders/SequencesUpload.vue";
import CardData from "@/components/CardData.vue";
import HelperImageUpload from "@/components/uploaders/HelperImageUpload.vue";

export default {
  components: {
    CardsUpload,
    ImagesUpload,
    BuildMatchups,
    SetQuestions,
    SequencesUpload,
    EditProject,
    CardData,
    HelperImageUpload,
  },
  data() {
    return {
      loading: true,
      token: this.$store.state.login.token,
      apiUrl: this.$store.state.api.url,
      frontUrl: `${process.env.VUE_APP_FRONTURL}/#/quiz`,
      clientId: this.$route.params.clientId,
      projectId: this.$route.params.projectId,
      imgPath: `${this.$store.state.api.url}/uploads/${this.$route.params.projectId}/images`,
      helperImgPath: `${this.$store.state.api.url}/uploads/${this.$route.params.projectId}/help_images`,
      projectFields: [
        {
          key: "title",
          label: "Project title",
        },
        {
          key: "isActive",
          label: "Status",
          /*formatter: (value) => {
            return value === true ? "Active" : "Inactive";
          },*/
        },
        {
          key: "cards",
          label: "Cards",
        },
        {
          key: "matchups",
          label: "Matchups",
        },
        {
          key: "results",
          label: "Results",
        },
        {
          key: "actions",
          label: "",
        },
      ],
    };
  },
  computed: mapState({
    client: (state) => state.api.selectedClient,
    project: (state) => state.api.selectedProject,
    cards: (state) => state.api.projectCards,
  }),
  mounted: function() {},
  created() {
    let clientId = this.$route.params.clientId;
    let projectId = this.$route.params.projectId;

    this.$store.dispatch("api/fetchProject", projectId);

    this.$store.dispatch("api/fetchClient", clientId);

    this.$store.dispatch("api/fetchProjectCards", projectId);
  },
  methods: {
    toggleProjectStatus: function() {
      this.$store
        .dispatch("api/toggleProjectStatus", this.project.id)
        .then(() => {
          this.$router.go();
        })
        .catch((err) => console.log(err));
    },
    toggleProjectOrder: function() {
      this.$store
        .dispatch("api/toggleProjectOrder", this.project.id)
        .then(() => {
          this.$router.go();
        })
        .catch((err) => console.log(err));
    },
    toggleProjectCompare: function() {
      this.$store
        .dispatch("api/toggleProjectCompare", this.project.id)
        .then(() => {
          this.$router.go();
        })
        .catch((err) => console.log(err));
    },
    deleteSequences: function() {
      this.$confirm({
        message: `Si prepričan? `,
        button: {
          no: "Prekliči",
          yes: "DA",
        },

        callback: (confirm) => {
          if (confirm) {
            this.$store
              .dispatch("api/deleteProjectSequences", this.project.id)
              .then(() => {
                this.$router.go();
              })
              .catch((err) => console.log(err));
          }
        },
      });
    },
    deleteImages: function() {
      this.$confirm({
        message: `Si prepričan? `,
        button: {
          no: "Prekliči",
          yes: "DA",
        },

        callback: (confirm) => {
          if (confirm) {
            this.$store
              .dispatch("api/deleteProjectImages", this.project.id)
              .then(() => {
                this.$router.go();
              })
              .catch((err) => console.log(err));
          }
        },
      });
    },
    deleteCards: function() {
      this.$confirm({
        message: `Si prepričan? `,
        button: {
          no: "Prekliči",
          yes: "DA",
        },

        callback: (confirm) => {
          if (confirm) {
            this.$store
              .dispatch("api/deleteCards", this.project.id)
              .then(() => {
                this.$router.go();
              })
              .catch((err) => console.log(err));
          }
        },
      });
    },
    deleteResults: function() {
      this.$confirm({
        message: `Si prepričan? `,
        button: {
          no: "Prekliči",
          yes: "DA",
        },

        callback: (confirm) => {
          if (confirm) {
            this.$store
              .dispatch("api/deleteResults", this.project.id)
              .then(() => {
                this.$router.go();
              })
              .catch((err) => console.log(err));
          }
        },
      });
    },
  },
};
</script>
